export const access_token = localStorage.getItem("access_token");
export const access_id = localStorage.getItem("access_id");
export const bottoken = localStorage.getItem("bottoken");
export const bot_id = localStorage.getItem("bot_id");
export const botname = localStorage.getItem("botname");